import { styled } from 'styled-components'
import { theme } from './theme'

export const Styled_Header_Page = styled.header<{ $isHidden: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1200px;
  display: grid;
  grid-template-columns: auto 1fr auto auto; // 로고는 고정 크기, 가운데는 가변 크기
  padding: 15px 20px;
  height: 65px; // 헤더의 고정 높이
  background-color: ${theme.colors.white};
  border-bottom: 2px solid ${theme.colors.green};
  font-weight: bold;
  z-index: 20;
  padding-left: calc((100vw - 2000px) / 2); /* 2000px을 넘는 경우 양쪽에 패딩 */
  padding-right: calc((100vw - 2000px) / 2);
  transform: translateY(${(props) => (props.$isHidden ? '-100%' : '0')});
  transition: transform 0.5s ease-in-out;
  li {
    display: none;
  }
  &.expanded {
    height: min-content; /* 확장된 높이 */
    li {
      display: block;
    }
  }
`

export const Logo = styled.div`
  display: flex;
  height: 42px;
  min-width: 80px;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  img {
    height: 50px;
    width: auto;
  }
`

export const Welcome = styled.p`
  display: flex;
  height: 42px;
  min-width: 120px;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0px 10px;
  & > strong {
    color: ${theme.colors.green};
    cursor: pointer;
    opacity: 0.9;
    &:hover {
      opacity: 1; /* 호버 시 색상 (진한 파란색) */
      transform: scale(1.05); /* 호버 시 약간 확대 효과 */
    }
  }
`

export const Logout_Btn = styled.button`
  display: flex;
  height: 42px;
  min-width: 80px;
  justify-content: center;
  align-items: center;
`

export const Menu = styled.nav<{ $pathname: string }>`
  display: flex;
  padding-left: 100px;
  gap: 50px; // 메뉴 아이템 간의 간격
  position: relative;
  label,
  li {
    border-radius: 10px;
    &[data-link="${(props) => props.$pathname}"] {
      color: ${theme.colors.green};
    }
  }
`

export const DropdownMenu = styled.ul`
  display: block; /* 기본적으로 숨김 */
  position: relative;
  cursor: pointer;
  min-width: 110px;
  label {
    display: block;
    padding: 8px 12px;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: ${theme.colors.blackgray};
    }
  }

  li {
    padding: 8px 12px;
    white-space: nowrap;
    &:hover {
      color: ${theme.colors.blackgray};
    }
  }
`
